import { joinUrl } from './joinUrl';

// Get the current API base URL dynamically
const getBaseUrl = (): string => {
  // In development, try to use the cached ngrok URL if available
  if (import.meta.env.DEV && import.meta.env.VITE_USE_NGROK === 'true') {
    // Check if we have a cached ngrok URL from the main api service
    const cachedUrl = (window as any).__NGROK_URL_CACHE__;
    if (cachedUrl) {
      return cachedUrl;
    }
  }
  
  return import.meta.env.VITE_API_URL;
};

function getToken() {
  return localStorage.getItem('access_token');
}

function getHeaders(isPublic = false) {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (!isPublic) {
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

export const apiService = {
  async get<T = any>(path: string, options: { isPublic?: boolean } = {}) {
    const url = joinUrl(getBaseUrl(), path);
    const res = await fetch(url, {
      method: 'GET',
      headers: getHeaders(options.isPublic),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json() as Promise<T>;
  },

  async post<T = any>(path: string, body: any, options: { isPublic?: boolean } = {}) {
    const url = joinUrl(getBaseUrl(), path);
    const res = await fetch(url, {
      method: 'POST',
      headers: getHeaders(options.isPublic),
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json() as Promise<T>;
  },

  // Add put, delete, etc. as needed
}; 